import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { putField } from "../../../../utils/form";
import { callMainObjective, callMainOperation as callRequestOperation } from "../request/haz-discuss-info/haz-discuss-info.section";
import lodash from "lodash";

export const callDocumentStatus = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "DOCUMENT_STATUS", value: searchQuery });

export const requiredSolidOrLiquid = ({ data, key }) => {
    return {
        validator: () => {
            const modelRef = data.useForm?.modelRef || data.form;
            const model = key ? lodash.get(modelRef, key) : modelRef;
            if (model.refHazDiscussTemp.isSolid !== true && model.refHazDiscussTemp.isLiquid !== true) {
                return Promise.reject(i18n.global.t("views.request.hazInfo.error.isSolidOrIsLiquid"));
            }
            return Promise.resolve();
        },
        trigger: "change"
    };
};

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.hazDiscuss.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            customRender: ({ record }) => {
                if (record.refUserCompany?.refPersonType?.key === "1") {
                    return <div>{record.refUserCompany?.companyNameTh}</div>;
                }
                return <div>{record.refUserCompany?.fullNameTh}</div>;
            }
        }),
        createColumnInput({ title: () => i18n.global.t("model.hazDiscuss.approveCode"), dataIndex: "approveCode", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.hazDiscuss.effectiveDate"), dataIndex: "effectiveDate", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.hazDiscuss.expireDate"), dataIndex: "expireDate", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.hazDiscuss.tradeNameTh"), dataIndex: "tradeNameTh" }),
        createColumnSelect({
            title: () => i18n.global.t("model.hazDiscuss.refOperation"),
            dataIndex: "refMainOperation.value",
            inputProp: () => ({ list: callRequestOperation, optLabel: "value" }),
            search: { name: "refMainOperation.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.hazDiscuss.refMainObjective"),
            dataIndex: "refMainObjective.value",
            inputProp: () => ({ list: callMainObjective, optLabel: "value" }),
            search: { name: "refMainObjective.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.hazDiscuss.refStatus"),
            dataIndex: "refStatus.value",
            customRender: ({ record }) => <div>{record.refStatus?.value}</div>,
            inputProp: () => ({ list: callDocumentStatus, optLabel: "value" }),
            align: "center",
            search: { name: "refStatus.id" },
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
